export const BATCH_ROW_SET_ACTIVE = 'BATCH_ROW_SET_ACTIVE';
export const ARCHIVE_BATCHES_REQUEST = 'ARCHIVE_BATCHES_REQUEST';
export const ARCHIVE_BATCHES_SUCCESS = 'ARCHIVE_BATCHES_SUCCESS';
export const ARCHIVE_BATCHES_FAILURE = 'ARCHIVE_BATCHES_FAILURE';
export const SET_SELECTED_BATCHES_BY_IDS = 'SET_SELECTED_BATCHES_BY_IDS';
export const VALIDATE_BATCHES_ADDRESSES_REQUEST = 'VALIDATE_BATCHES_ADDRESSES_REQUEST';
export const SEND_EMAIL_FOR_BATCHES_REQUEST = 'SEND_EMAIL_FOR_BATCHES_REQUEST';
export const SEND_NOTIFICATIONS_FOR_BATCHES_REQUEST = 'SEND_NOTIFICATIONS_FOR_BATCHES_REQUEST';
export const UPDATE_BATCH_GRID_SORTING = 'UPDATE_BATCH_GRID_SORTING';
export const UPDATE_FILTER_SEARCH_TERM = 'UPDATE_FILTER_SEARCH_TERM';
export const GRID_FILTER_SEARCH = 'GRID_FILTER_SEARCH';

export const GET_BATCH_ROW_REQUEST = 'GET_BATCH_ROW_REQUEST';
export const getBatchRows = () => ({
  type: GET_BATCH_ROW_REQUEST,
});

export const GET_BATCH_ROW_SUCCESS = 'GET_BATCH_ROW_SUCCESS';
export const getBatchRowsSuccess = (batchData) => ({
  type: GET_BATCH_ROW_SUCCESS,
  batchData,
});

export const GET_BATCH_ROW_FAILURE = 'GET_BATCH_ROW_FAILURE';
export const getBatchRowsFailure = (error) => ({
  type: GET_BATCH_ROW_FAILURE,
  error,
});

export const setActiveBatches = (batchData) => ({
  type: BATCH_ROW_SET_ACTIVE,
  batchData,
});

export const archiveBatches = (fulfillmentPlanSetIds) => ({
  type: ARCHIVE_BATCHES_REQUEST,
  fulfillmentPlanSetIds,
});

export const archiveBatchesSuccess = () => ({
  type: ARCHIVE_BATCHES_SUCCESS,
});

export const archiveBatchesFailure = (error) => ({
  type: ARCHIVE_BATCHES_FAILURE,
  error,
});

export const setSelectedBatchesByIds = (fulfillmentPlanSetIds) => ({
  type: SET_SELECTED_BATCHES_BY_IDS,
  fulfillmentPlanSetIds,
});

export const validateBatchesAddresses = (fulfillmentPlanSetIds) => ({
  type: VALIDATE_BATCHES_ADDRESSES_REQUEST,
  fulfillmentPlanSetIds,
});

export const sendEmailForBatches = (fulfillmentPlanSetIds) => ({
  type: SEND_EMAIL_FOR_BATCHES_REQUEST,
  fulfillmentPlanSetIds,
});

export const sendNotificationsForBatches = (fulfillmentPlanSetIds) => ({
  type: SEND_NOTIFICATIONS_FOR_BATCHES_REQUEST,
  fulfillmentPlanSetIds,
});

export const updateBatchGridSorting = (sortBy) => ({
  type: UPDATE_BATCH_GRID_SORTING,
  sortBy,
});

export const gridSearch = (searchTerm) => ({
  type: GRID_FILTER_SEARCH,
  searchTerm,
});

export const updateSearchTerm = (searchTerm) => ({
  type: UPDATE_FILTER_SEARCH_TERM,
  searchTerm,
});
